<template>
  <div>
    <page-header title="Member Login"></page-header>
    <div class="container">
      <!-- Before sending 2fa -->
      <div class="row mb-5" v-if="!sent2fa">
        <div class="col col-md-6 card">
          <p>
            Please enter your work email to get a 2FA code. You must be an
            approved member of CTO Circle to access our community resources.
          </p>
          <form class="form" @submit.prevent="sendCode">
            <div class="form-group">
              <label>Work email</label>
              <input
                type="email"
                class="form-control"
                v-model="email"
                required
                :disabled="sent2fa"
              />
            </div>
            <button
              class="btn btn-primary"
              type="button"
              disabled
              v-if="loading"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Sending...
            </button>
            <button type="submit" class="btn btn-primary" v-else>
              Get 2FA
            </button>
            <p class="mt-3">
              Not a member yet?
              <a
                href="https://csuitecircle.typeform.com/to/fEytYh02"
                target="_blank"
                >Request an invite</a
              >
            </p>
          </form>
        </div>
      </div>

      <!-- After sending 2fa -->
      <div class="row mb-5" v-if="sent2fa">
        <div class="col col-md-6 card">
          <p v-if="resent2fa">
            The code has been resent to <strong>{{ email }}</strong
            >.
          </p>
          <p v-else>
            Please enter the authentication code sent to
            <strong>{{ email }}</strong
            >.
          </p>
          <form class="form" @submit.prevent="login">
            <div class="form-group">
              <label>Authentication Code</label>
              <input
                type="number"
                class="form-control"
                v-model="code"
                required
              />
            </div>
            <button
              class="btn btn-primary"
              type="button"
              disabled
              v-if="loading"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </button>
            <button type="submit" class="btn btn-primary" v-else>Login</button>
            <button
              type="button"
              class="btn btn-outline-secondary ml-3"
              @click="resendCode"
            >
              Resend Code
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/global/PageHeader';
import { InsertOTP, InsertToken } from '@/gql/Login.gql';

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      email: '',
      code: '',
      sent2fa: false,
      resent2fa: false,
      loading: false
    };
  },
  methods: {
    async sendCode() {
      this.loading = true;
      let otp = await this.$apollo
        .mutate({
          mutation: InsertOTP,
          variables: {
            email: this.email
          }
        })
        .then(() => {
          this.loading = false;
          this.sent2fa = true;
        })
        .catch(err => {
          alert(err.graphQLErrors.map(err => err.message).join(', '));
          this.loading = false;
        });
    },
    async login() {
      this.loading = true;
      let tokenResponse = await this.$apollo
        .mutate({
          mutation: InsertToken,
          variables: {
            email: this.email,
            code: this.code
          }
        })
        .then(({ data }) => {
          const token = data.insert_Token;
          localStorage.token = token;
          this.loading = false;
          window.location.href = '/';
        })
        .catch(err => {
          alert(err.graphQLErrors.map(err => err.message).join(', '));
          this.loading = false;
        });
    },

    resendCode() {
      this.resent2fa = true;
      this.sendCode();
    }
  }
};
</script>
